import { render, staticRenderFns } from "./SacrificedGlyphs.vue?vue&type=template&id=752b137d&scoped=true&"
import script from "./SacrificedGlyphs.vue?vue&type=script&lang=js&"
export * from "./SacrificedGlyphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b137d",
  null
  
)

export default component.exports